import React, { useState, useEffect } from 'react';
import './DetectionOutput.css';

function DetectionOutput() {
  const [output, setOutput] = useState([]);

  useEffect(() => {
    // Polling to fetch the latest detection output every 2 seconds
    const interval = setInterval(async () => {
      try {
        const response = await fetch('http://localhost:5000/get_output'); // Replace with actual Flask API endpoint
        const data = await response.json();
        setOutput(data); // Data is already ordered with new detections at the top
      } catch (error) {
        console.error('Error fetching output:', error);
      }
    }, 2000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="detection-output">
      <h2>Detection Output</h2>
      {output.length > 0 ? (
        <ul className="output-details">
          {output.map((item, index) => (
            <li key={index}>
              <strong>Weapon:</strong> {item.label} <br />
              <strong>Confidence:</strong> {item.confidence.toFixed(2)} <br />
              <strong>Strategy:</strong> {item.strategy} <br />
              <strong>Timestamp:</strong> {item.timestamp}
            </li>
          ))}
        </ul>
      ) : (
        <p>No detections yet...</p>
      )}
    </div>
  );
}

export default DetectionOutput;
